// extracted by mini-css-extract-plugin
export default {"container":"zdzbi","notFirstItem":"_3ZPqW","pimple":"Y9KAX","pimpleFullButton":"_2l38j","pimpleHollowButton":"_3qR9R","updatedIndicationText":"_3la61"};